// extracted by mini-css-extract-plugin
export var modal = "_f1-0";